import { Map } from "mapbox-gl";
import { connect } from "react-redux";
import { BasePosition } from "../model/rounds";
import { ApplicationState } from "../reducers";
import { MapViewType } from "./MapViewType";

export interface MapboxProps {
  positions: BasePosition[];
}

export interface OwnProps {
  map: Map;
  loaded: boolean;
  mapType?: MapViewType;
}

export interface Props extends OwnProps, MapboxProps {}

function addLocalLocationLayer(map: Map) {
  // @ts-ignore
  map.loadImage("images/gun.png", (error3, image) => {
    if (!map.hasImage("gun_img")) {
      map.addImage("gun_img", image);
    }
    if (!map.getLayer("standplass")) {
      map.addLayer({
        id: "standplass",
        layout: {
          "icon-allow-overlap": true,
          "icon-anchor": "center",
          "icon-image": "gun_img",
          "text-allow-overlap": true,
          "text-anchor": "center",
        },
        source: "standplass",
        type: "symbol",
      });
    }
  });
}

function addLocalLocationSource(localLocation: BasePosition[], map: Map) {
  map.addSource("standplass", {
    data: devicePoints(localLocation),
    type: "geojson",
  });
}

export const devicePoints = (
  positions: BasePosition[]
): GeoJSON.FeatureCollection => {
  return {
    features: createFeatures(positions),
    type: "FeatureCollection",
  };
};

const createFeatures = (positions: BasePosition[]): any => {
  return positions.map((position) => {
    return {
      geometry: {
        coordinates: [position.lon, position.lat],
        type: "Point",
      },
      properties: {
        id: `${position.lon}_${position.lat}`,
      },
      type: "Feature",
    };
  });
};

function updateLocalLocationSource(positions: BasePosition[], map: Map) {
  map
    .getSource("standplass")
    // @ts-ignore
    .setData(devicePoints(positions));
}

const StandplassLayer = ({ map, loaded, positions }: Props) => {
  if (map && loaded) {
    if (!map.getSource("standplass")) {
      addLocalLocationSource(positions, map);
      addLocalLocationLayer(map);
    } else {
      updateLocalLocationSource(positions, map);
    }
  }

  return null;
};

const mapStateToProps = (state: ApplicationState) => {
  const selectedRound = state.round.selectedRound;

  return {
    positions: selectedRound
      ? [selectedRound.observations[0].device.position.master]
      : [],
  };
};

// @ts-ignore
export default connect<MapboxProps, {}, {}>(mapStateToProps)(StandplassLayer);
